import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { CustomDropdownWithFadeBox }
    from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";
import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import { CustomAppEventListener } from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController.js';
import * as CustomForm from 'Flow2/components/CustomCollections/CustomDataControllers/CustomFormController';
import StoreHelper from 'Flow2/components/Article/Helpers/StoreHelper';
import SearchHelper from 'Flow2/components/Article/Helpers/SearchHelper';
import Countries from 'Flow2/components/CustomCollections/CustomDataJson/countries.json';
import './DropdownWithFadeBox.scss';


class DropdownWithFadeBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customDataObjects: {},
            condition: {
                name: "customdisplay", value: "customdisplay",
                ext: { name: "customdisplay", value: "customdisplay" }
            },
            data: []
        }
    }

    closeAllDropDowns = () => {
        Object.keys(this.state).map((key) => {
            if ((this.state[key] === "block") && (!key.includes("SubmenuShow"))
                && (!key.includes("SectionShow")) && (!key.includes("MessageBox"))) {
                this.setState({ [key]: "none" });
            }
            if ((this.state[key] === CustomAppEventListener(CustomEvents.GET_ICON, "arrowUpIcon"))
                && (!key.includes("SubmenuShow")) && (!key.includes("SectionShow"))) {
                this.setState({ [key]: CustomAppEventListener(CustomEvents.GET_ICON, "arrowDownIcon") });
            }
        })
    };

    onDeleteClick = (item) => () => {
        this.setState({ [`${item.name}_tmp`]: "" });
        this.setState({ [`selected${item.name}s`]: this.state[`${item.name}CustomData`] });
    }

    getDataString = (data) => data.map(item => item.ID).join(";");

    onPageClick = (event) => {
        if (!event.target.name) this.closeAllDropDowns();
    }

    toggleDropDown = (stateName) => {
        this.closeAllDropDowns();
        if (this.state[stateName] === "none") this.setState({ [stateName]: "block" });
        else this.setState({ [stateName]: "none" });
    };

    openDropDown = (stateName) => {
        if (!this.state[stateName] || this.state[stateName] === "none") {
            this.closeAllDropDowns();
            this.setState({ [stateName]: "block" });
        }
    };

    setUserList = () => {
        if (this.props.users && this.props.users.length) {
            return this.props.users.map(item => ({
                ID: item.id || item.ID || item.Id
                    || item.username, intl: SearchHelper.getUserName(item)
            }));
        }
    }

    convertData = (data) => {
        const { listType } = this.props;
        if (listType && (listType === ArticleTypes.USERLIST || listType === ArticleTypes.USERSLIST)) return this.setUserList();
        if (listType && listType === ArticleTypes.COUNTRYLIST) return Countries;
        if (data && data.length) {
            if (!data.every(item => item.ID)) {
                return data.map(item => {
                    if (item.value) return ({ ...item, ID: item.value });
                    if (item.id) return ({ ...item, ID: item.id });
                    return item;
                })
            }
            return data;
        }
        return [];
    }

    getSelectedItems = ({ event, items, lg, ddname, isSingle }) => {
        let { name, value } = event.target;
        let found = items.find(el => (el.ID === parseInt(name) || el.ID === name));
        if (!found) {
            if (this.state[`selected${ddname}s`]) {
                let exist = this.state[`selected${ddname}s`].find(el => el.ID == name);
                if (exist) {
                    if (isSingle) items = [exist];
                    else items.push(exist);
                }
                else items.push({ ID: name, [lg]: value })
            }
        }
        return items;
    }

    onFadeBoxDropDownRemoveItems = (ddname, id) => {
        const { customDataObjects } = this.state;
        let updatedObjects = this.state[`${ddname}Items`].filter(item => item.ID !== id);
        let elementsIds = this.getDataString(updatedObjects);
        this.setState({
            [`${ddname}Items`]: updatedObjects,
            [`${ddname}_apptmp`]: elementsIds,
            customDataObjects: { ...customDataObjects, [`${ddname}`]: elementsIds, [`${ddname}_ids`]: elementsIds }
        });

        if (this.props.freeType && this.props.updateCallback) {
            this.props.updateCallback(ddname, elementsIds);
        } else {
            StoreHelper.checkAndUpdateDataObj({
                updateDataObjects: this.props.updateDataObjects,
                mainObj: this.props.mainObj, subObjName: this.props.subObjName,
                name: ddname, value: elementsIds
            });
        }

        if ((this.state[`${ddname}Items`] && this.state[`${ddname}Items`].length === 1)) {
            this.setState({
                [`${ddname}_tmp`]: '',
                [`${ddname}_apptmp`]: '',
                [`${ddname}_tmp`]: "",
                [`selected${ddname}s`]: this.state[`${ddname}CustomData`],
            });
        }
    }

    onDropDownIconClick = (name, data) => {
        this.closeAllDropDowns();
        if (!this.state[`${name}Show`]) this.setState({ [`${name}Show`]: "block" });
        else this.toggleDropDown(`${name}Show`);

        if ((!this.state[`${name}CustomData`] || !DataUtil.isDataArray(this.state[`${name}CustomData`])
            || (this.props.newData && this.props.newData[name])
            || CustomForm.refreshApiContentForApp(name, this.props))) {
            this.setState({ [`${name}CustomData`]: data, [`selected${name}s`]: data }, () => {
                if (!this.state[`${name}Items`]) this.setState({ [`${name}Items`]: [] });
            });
        }
        if (!this.state[`selected${name}s`] || !this.state[`selected${name}s`].length) {
            this.setState({ [`selected${name}s`]: data });
        }
    }

    getSelectedData = (name, value) => {
        let selectedData = [];
        value = value.trimStart();
        selectedData = this.state[name].filter(item =>
            this.props.intl.formatMessage({ id: item.intl })
                .toLowerCase().includes(value.toLowerCase())
        );
        return selectedData;
    };

    updateSearchData = (e, name, data) => {
        let value = e.target.value;
        value = value.trimStart();
        let searchData = data.filter(item => {
            return this.props.intl.formatMessage({ id: item.intl })
                .toLowerCase().includes(value.toLowerCase());
        }
        );
        this.setState({ [name]: searchData });
    };

    onFadeBoxDropDownDataHandleClick = (ddname, isSingle, event) => {
        try {
            if (event.target.name && event.target.name === "CustomFakeId") {
                this.setCustomFakeItem(ddname);
            }
            else {
                const { customDataObjects } = this.state;
                let lg = DataUtil.getLanguage(this.props.lg);
                let updatedObjects = this.getSelectedItems({ event, items: this.state[`${ddname}Items`], lg, ddname, isSingle });
                let elementsIds = this.getDataString(updatedObjects, true);
                this.setState({
                    [`${ddname}Items`]: updatedObjects,
                    [`${ddname}_apptmp`]: elementsIds,
                    customDataObjects: { ...customDataObjects, [ddname]: elementsIds, [`${ddname}_ids`]: elementsIds }
                });

                if (this.props.freeType && this.props.updateCallback) {
                    this.props.updateCallback(ddname, elementsIds);
                } else {
                    StoreHelper.checkAndUpdateDataObj({
                        updateDataObjects: this.props.updateDataObjects,
                        mainObj: this.props.mainObj, subObjName: this.props.subObjName,
                        name: ddname, value: elementsIds
                    });
                }

                if (this.props.autoClose) this.closeAllDropDowns();
            }

        } catch (eror) {
            console.log("Data not found!!");
        }
    }
    onFadeBoxDropDownDataChange = (name, data, event) => {
        try {
            const { value } = event.target;
            this.openDropDown(`${name}Show`);
            if (!this.state[`${name}CustomData`] || (this.props.newData && this.props.newData[name])) {
                if (!this.state[`${name}Items`]) this.setState({ [`${name}Items`]: [] });
                this.setState({ [`${name}CustomData`]: data, [`selected${name}s`]: data });
                this.updateSearchData(event, `selected${name}s`, data);
            }
            else this.updateSearchData(event, `selected${name}s`, this.state[`${name}CustomData`]);
            let selecteddata = this.getSelectedData(`${name}CustomData`, value);
            this.setState({ [`selected${name}s`]: selecteddata, [`${name}_tmp`]: value });
        } catch (eror) {
            console.log("Data not found!");
        }
    }

    setUpSavedData = () => {
        const { current, item } = this.props;
        let value = current ? current : '';
        let savedItems = [];
        if (current && item && item.data) {
            let curArr = current.split(";");
            savedItems = item.data.filter(item => curArr.find(el => el === item.ID));
        }
        const { customDataObjects } = this.state;
        this.setState({
            [`selected${item.name}s`]: savedItems,
            [`${item.name}Items`]: savedItems,
            [`${item.name}`]: value,
            customDataObjects: { ...customDataObjects, [`${item.name}_ids`]: value, [`${item.name}`]: value }
        });
    }

    setUpDropDownData = () => this.setState({ data: this.convertData(this.props.item.data) });

    componentDidUpdate(prev) {
        if (prev.current != this.props.current) this.setUpSavedData();
        if (prev.item.data != this.props.item.data) this.setUpDropDownData();
    }

    componentDidMount() {
        this.setUpDropDownData();
        this.setUpSavedData();
    }

    render() {
        const { item } = this.props;
        return (
            <div className={this.props.noLabel ? "DropdownWithFadeBoxNoLabel" : "DropdownWithFadeBox"} onClick={this.onPageClick}>
                <CustomDropdownWithFadeBox
                    customdisplay={this.state[`${this.state.condition.name}_apptmp`]}
                    condition={this.state.condition} mandatory={item.mandatory}
                    lg={this.props.lg} key={`key${item.name}`}
                    label={item.label ? item.label : null}
                    sorted={item.sorted ? item.sorted : false}
                    display={this.state[`${item.name}Show`] ? this.state[`${item.name}Show`] : "none"}
                    fMsgId={item.intl} formatMessage={this.props.intl.formatMessage}
                    inputType='text' onDeleteClick={this.onDeleteClick(item)}
                    onDdRemoveItems={this.onFadeBoxDropDownRemoveItems.bind(this, item.name)}
                    onDdInputClick={this.onDropDownIconClick.bind(this, item.name, this.state.data)}
                    onDdInputChange={this.onFadeBoxDropDownDataChange.bind(this, item.name, this.state.data)}
                    onDataClick={this.onFadeBoxDropDownDataHandleClick.bind(this, item.name, this.props.isSingle)}
                    inputValue={this.state.isDeleted ? "" : this.state[`${item.name}_tmp`]} name={item.name}
                    data={this.state[`selected${item.name}s`] ? this.state[`selected${item.name}s`] : this.state.data}
                    dataItems={this.state[`${item.name}Items`] ? this.state[`${item.name}Items`] : []}
                    requiredField={this.props.isRequired} hideLabel={this.props.hideLabel} />
            </div>)
    }
}

const mapStateToProps = (state) => ({
    users: state.admin.users,
    uiConfig: state.customData.customUiConfigForApp,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DropdownWithFadeBox));